/**
 * Map of valid reason code options handled by the app
 *
 * @type {Object}
 */
export const reasonCodes = {
    'UM': { id: 'UM', description: 'Unique material', color: '#00818F'},
    'BD': { id: 'BD', description: 'Business decision', color: '#16A4EB'},
    'RF': { id: 'RF', description: 'BCP Ready - Paper Pack', color: '#E48932'},
    'AM': { id: 'AM', description: 'Alternative material', color: '#8F4899'},
};

/**
 * List of the material categories eligible for RF reason code
 * @type {string[]}
 */
export const spendCategoriesForRF = [
    'Corrugated',
    'Microflute',
    'Solid Board',
    'Paper',
    'Label',
    'Sleeve',
];

/**
 * Test if a material row has a category eligible to use the RF reason code
 * @param {Object} obj
 * @return {boolean}
 */
export const isMaterialEligibleForRF = (obj) => {
    return spendCategoriesForRF.includes(obj['spendCategory1']);
}
